import script from "./MainForm.vue?vue&type=script&setup=true&language=javascript&lang=js"
export * from "./MainForm.vue?vue&type=script&setup=true&language=javascript&lang=js"

import "./MainForm.vue?vue&type=style&index=0&id=0ac9bb14&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/ReftabHelperWww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac9bb14"]])

export default __exports__